import { cva } from 'class-variance-authority'

export const tabsHeader = cva([' flex transition-all'])
